<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="该批板">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">光沢</div>
                <div v-if="!tlGpbCheckInfo.guangze_result" style="color: red">{{tlGpbCheckInfo.guangze_value}}</div>
                <div v-else>{{tlGpbCheckInfo.guangze_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">膜厚</div>
                <div v-if="!tlGpbCheckInfo.mohou_result" style="color: red">{{tlGpbCheckInfo.mohou_value}}</div>
                <div v-else>{{tlGpbCheckInfo.mohou_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">L*</div>
                <div v-if="!tlGpbCheckInfo.l_result" style="color: red">{{tlGpbCheckInfo.l_value}}</div>
                <div v-else>{{tlGpbCheckInfo.l_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">a*</div>
                <div v-if="!tlGpbCheckInfo.a_result" style="color: red">{{tlGpbCheckInfo.a_value}}</div>
                <div v-else>{{tlGpbCheckInfo.a_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">b*</div>
                <div v-if="!tlGpbCheckInfo.b_result" style="color: red">{{tlGpbCheckInfo.b_value}}</div>
                <div v-else>{{tlGpbCheckInfo.b_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">ΔE</div>
                <div v-if="!tlGpbCheckInfo.e_result" style="color: red">{{tlGpbCheckInfo.e_value}}</div>
                <div v-else>{{tlGpbCheckInfo.e_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{tlGpbCheckInfo.create_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{tlGpbCheckInfo.create_time}}</div>
              </div>
            </div>
            <div class="detail" v-show="tlSybCheckInfo.pictures_pics_ids !== ''">
              <div class="nowrapDiv">
                <div class="fontBold">照片</div>
              </div>
              <el-image v-for="imageUrl in tlGpbCheckInfo.pictures_pics_list" :preview-src-list="tlGpbCheckInfo.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="试验板" :disabled="tlSybCheckInfo === null">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">光沢</div>
                <div v-if="!tlSybCheckInfo.guangze_result" style="color: red">{{tlSybCheckInfo.guangze_value}}</div>
                <div v-else>{{tlSybCheckInfo.guangze_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">膜厚</div>
                <div v-if="!tlSybCheckInfo.mohou_result" style="color: red">{{tlSybCheckInfo.mohou_value}}</div>
                <div v-else>{{tlSybCheckInfo.mohou_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">L*</div>
                <div v-if="!tlSybCheckInfo.l_result" style="color: red">{{tlSybCheckInfo.l_value}}</div>
                <div v-else>{{tlSybCheckInfo.l_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">a*</div>
                <div v-if="!tlSybCheckInfo.a_result" style="color: red">{{tlSybCheckInfo.a_value}}</div>
                <div v-else>{{tlSybCheckInfo.a_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">b*</div>
                <div v-if="!tlSybCheckInfo.b_result" style="color: red">{{tlSybCheckInfo.b_value}}</div>
                <div v-else>{{tlSybCheckInfo.b_value}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">ΔE</div>
                <div v-if="!tlSybCheckInfo.e_result" style="color: red">{{tlSybCheckInfo.e_value}}</div>
                <div v-else>{{tlSybCheckInfo.e_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">耐溶剂</div>
                <div>{{tlSybCheckInfo.naiRongJi}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">附着性</div>
                <div>{{tlSybCheckInfo.fzx_text}}</div>
                <div style="padding: 0 0 0 15px">{{tlSybCheckInfo.fzx_value}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">耐冲击</div>
                <div>{{tlSybCheckInfo.naiChongJi}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">硬度</div>
                <div>{{tlSybCheckInfo.yingDu}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">判定</div>
                <div>{{tlSybCheckInfo.result}}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{tlSybCheckInfo.create_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{tlSybCheckInfo.create_time}}</div>
              </div>
            </div>
            <div class="detail" v-show="tlSybCheckInfo.pictures_pics_ids !== ''">
              <div class="nowrapDiv">
                <div class="fontBold">照片</div>
              </div>
              <el-image v-for="imageUrl in tlSybCheckInfo.pictures_pics_list" :preview-src-list="tlSybCheckInfo.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "BusTlCheckInfo",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return{
      tlGpbCheckInfo:'',
      tlSybCheckInfo:'',

    }
  },
  methods: {
    async getTlGpbInfo(){
      let {data: res} = await this.$axios.post('bus/tl/getTlGpbInfo',this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.tlGpbCheckInfo = res.data
      }
    },
    async getTlSybInfo(){
      let {data: res} = await this.$axios.post('bus/tl/getTlSybInfo',this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.tlSybCheckInfo = res.data
      }
    },
    test(){
      console.log(this.parentData)
    }
  },
  created() {
    this.test()
    this.getTlGpbInfo()
    this.getTlSybInfo()
  }
}
</script>

<style scoped>
.checkInfo {
  background-color: #F4F8FD;
  padding-top: 2px;
}

.detail {
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}

.detailDiv {
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fontBold {
  font-weight: bold;
}

.width1 {
  width: 25%;
}

.width2 {
  width: 39%;
}

.width3 {
  width: 12.5%;
}

.width4 {
  width: 30%;
}

.width5 {
  width: 50%;
}

.nowrapDiv {
  display: flex;
  flex-wrap: nowrap;
}

.ngdiv {
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}

.ngdiv1 {
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}

.imageStyle {
  width: 87px;
  height: 87px;
  margin-right: 5px
}

.imageStyle1 {
  width: 500px;
  height: 500px;
  margin-right: 5px
}

>>> .el-tabs--border-card > .el-tabs__content {
  padding: 1px !important;
}
</style>